module.exports = __webpack_public_path__ + "img/test2.2b2036e2.jpg";